import moment from "moment";
import IntlUtils from "services/intl/utils";
import ParkkiTheme from "themes/ParkkiTheme";

export class AlertEventsUtils {
  static formatDate(dateString) {
    const intl = IntlUtils.getIntlInstance();
    const eventDate = moment(dateString);
    const now = moment();

    if (eventDate.isSame(now, "day")) {
      const diffMinutes = now.diff(eventDate, "minutes");

      if (diffMinutes < 1) {
        return intl.formatMessage({ id: "alertsScene.instant" });
      } else if (diffMinutes < 60) {
        return intl.formatMessage(
          {
            id: "alertsScene.minutes",
          },
          { minutes: diffMinutes }
        );
      } else {
        const diffHours = now.diff(eventDate, "hours");
        return intl.formatMessage(
          { id: "alertsScene.hours" },
          { hours: diffHours }
        );
      }
    } else {
      return eventDate.format("DD/MM/YYYY HH:mm:ss");
    }
  }

  static getOutputColor(output) {
    const style = {
      backgroundColor: output.background_color || ParkkiTheme.colors.lightGrey,
    };
    if (output.text_color) {
      style.color = output.text_color;
    }
    return style;
  }
}
